import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }

    fetch(`${API}/auth/session`, {
      method: "POST",
      headers: { "X-Session-ID": sessionId },
      credentials: "include",
    })
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.detail || "Sign-in failed. Please try again.");
        return data;
      })
      .then(() => {
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true });
      })
      .catch((e) => {
        navigate(`/admin?error=${encodeURIComponent(e.message)}`, { replace: true });
      });
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background" data-testid="auth-callback">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
      <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">Signing you in…</p>
    </div>
  );
}
